module.exports = __webpack_public_path__ + "img/top.a8987d7f.png";